<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        :disabled="dialog"
        v-on="on"
      >
        <v-icon left>
          add
        </v-icon>
        Create User
      </v-btn>
    </template>
    <v-card>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="onSubmitForm"
      >
        <v-card-title>
          <span class="headline">Create User</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                v-if="errors"
                xs12
              >
                <div class="subheading error--text text-xs-center">
                  {{ errors }}
                </div>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="name"
                  :rules="nameRules"
                  label="Name"
                  placeholder="Enter user name"
                  required
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="Email"
                  placeholder="Enter user email"
                  required
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="password"
                  :rules="passwordRules"
                  label="Password"
                  placeholder="Enter user password"
                  required
                  type="password"
                />
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  v-model="active"
                  label="Activated"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            flat
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="isSubmitting"
            color="success"
            flat
            type="submit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data: () => ({
    dialog: false,
    valid: false,
    isSubmitting: false,
    name: '',
    email: '',
    password: '',
    active: false,
    errors: null,
    nameRules: [
      value => !!value || 'Required',
      value => (value && value.length <= 70) || 'Maximum 70 characters',
      value => (value && value.length >= 4) || 'Minimum 4 characters',
    ],
    emailRules: [
      value => !!value || 'E-mail is required',
      value => /.+@.+/.test(value) || 'E-mail must be valid'
    ],
    passwordRules: [
      value => !!value || 'Password is required',
      value => (value && value.length >= 8) || 'Password must be more than 8 characters'
    ],
  }),
  methods: {
    ...mapActions({
      createUsers: 'user/createUsers',
      getUsers: 'user/getUsers'
    }),
    onSubmitForm () {
      if (this.$refs.form.validate()) {
        this.isSubmitting = true
        this.createUsers({
          name: this.name,
          email: this.email,
          password: this.password,
          active: this.active
        }).then((response) => {
          if (response === 201) {
            this.getUsers({
              page: 1,
              rowsPerPage: 10
            }).then(() => {
              this.isSubmitting = false
              this.dialog = false
              this.name = ''
              this.email = ''
              this.password = ''
              this.active = false
              this.$refs.form.reset()
            })
          }
        }).catch((error) => {
          this.isSubmitting = false
          this.errors = error
        })
      }
    }
  }
}
</script>
